import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import type { DialogProps } from '@mui/material/Dialog';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  children?: React.ReactNode;
  onCancel: () => void;
  onOk: () => void;
  cancelText?: string;
  okText?: string;
  disableOk?: boolean;
  loading?: boolean;
  fullWidth?: DialogProps['fullWidth'];
  maxWidth?: DialogProps['maxWidth'];
  paperClassName?: string;
  titleClassName?: string;
  contentClassName?: string;
  actionsClassName?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  children,
  onCancel,
  onOk,
  cancelText = 'Cancel',
  okText = 'Confirm',
  disableOk = false,
  loading = false,
  fullWidth = true,
  maxWidth = 'sm',
  paperClassName,
  titleClassName,
  contentClassName,
  actionsClassName,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-labelledby="confirm-dialog-title"
      BackdropProps={{
        className: 'bg-black/50 backdrop-blur-sm'
      }}
      PaperProps={{
        className:
          `bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl ${paperClassName ?? ''}`
      }}
    >
      <DialogTitle
        id="confirm-dialog-title"
        className={`border-b border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100 ${titleClassName ?? ''}`}
      >
        {title}
      </DialogTitle>
      <DialogContent className={`text-gray-700 dark:text-gray-300 ${contentClassName ?? ''}`}>
        {children}
      </DialogContent>
      <DialogActions className={`border-t border-gray-200 dark:border-gray-700 ${actionsClassName ?? ''}`}>
        <Button onClick={onCancel} color="inherit" disabled={loading} className="!text-gray-700 dark:!text-gray-300">
          {cancelText}
        </Button>
        <Button onClick={onOk} color="primary" variant="contained" disabled={disableOk || loading} className="!text-white">
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;